<template>
	<div class="pageSettingDetail-body">
		<div class="fx-header header">
			<p class="header-p">我的页面装修编辑</p>
			<el-button size="mini" type='primary' v-if="AuthorityList['16_0005_0001_00']" @click="saveClick">保存</el-button>
		</div>
    <div class="gap"></div>
		<div class="body-box">
      <div class="left">
        <div class="component-title" @click="showItemBoxClick">
					<i class="el-icon-arrow-down margin-right-10" v-if="itemBoxIsShow"></i>
					<i class="el-icon-arrow-up margin-right-10" v-else></i>
					基础组件
				</div>
        <div class="item-box" v-if="itemBoxIsShow">
          <img src="~/images/icon/person-info.png"/>
          <div>个人信息</div>
          <div style="margin-top: 5px;">1/1</div>
        </div>
      </div>
      <div class="gap2"></div>
      <div class="mid">
        <div class="phone">
          <img src="~/images/icon/personInfo-text.png" class="notice"/>
					<img src="~/images/icon/me.png" class="phone-page"/>
					<div class="border"></div>
          <div style="position: absolute;">
            <w-image :src="imgurl" class="me-back-Img"></w-image>
            <div class="info" :style="'color:' + color">
              <div class="name">重庆馋嘴小吃</div>
              <div class="tel">18523929172</div>
              <div class="id">ID：202112</div>
            </div>
          </div>
        </div>
      </div>
      <div class="gap2"></div>
      <div class="right">
        <div class="title-box">
          <span>个人信息</span>
        </div>
        <div class="second-title">背景图片：</div>
        <div class="tips">图片尺寸建议750*344像素，图片大小1MB，图片格式png、jpg、jpeg，只能上传1张</div>
        <div class="uploadImgBox">
          <span class="upload-title">图片：</span>
					<div class="upload">
						<ImgUplaod
							:imgSrc.sync="imgurl"
						></ImgUplaod>
					</div>
          <el-link type="primary" class="default" @click="resetImage">重置系统默认图片</el-link>
        </div>
				<div class="color-box">
					<span class="color-title">个人信息文字颜色：</span>
					<div class="color-picker">
						<div v-for="(item, index) in colorItems" :key="index">
							<div class="color" :class="item.active === true ? 'active' : ''" @click="selectColor(item, index)">
								<div class="color-content" :style="'background:' + item.color"></div>
							</div>
						</div>
					</div>
					<el-link type="primary" class="default" @click="resetColor">重置系统默认颜色</el-link>
				</div>
      </div>
		</div>
	</div>
</template>
<script>
import ImgUplaod from '@/components/me/ImgUpload.vue'
export default {
	name: 'pageSettingDetail',
	components: {
		ImgUplaod
	},
	data () {
		return {
			itemBoxIsShow: true,
			imgurl: '',
			color: '',
			styleid: '',
			colorItems: [
				{
					color: '#FFFFFF',
					code: 0,
					active: true
				},
				{
					color: '#333333',
					code: 1,
					active: false
				}
			],
			AuthorityList: {
				'16_0005_0001_00': false
			}
		}
	},
	created () {
		this.getAuthority('16_0005_0000_00')
		this.getSetting()
	},
	mounted () {

	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		showItemBoxClick () {
			this.itemBoxIsShow = !this.itemBoxIsShow
		},
		selectColor (item, index) {
			if (item.code === 0) {
				this.colorItems[0].active = true
				this.colorItems[1].active = false
			} else {
				this.colorItems[0].active = false
				this.colorItems[1].active = true
			}
			this.color = item.color
		},
		resetImage () {
			this.imgurl = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/biubiuorder/headerpic/wechatappletheader.jpg?timestamp=' + new Date().getTime()
		},
		resetColor () {
			this.colorItems[0].active = true
			this.colorItems[1].active = false
			this.color = '#FFFFFF'
		},
		saveClick () {
			let imgUrlArr = this.imgurl.split('?')
			let length = imgUrlArr.length
			this.imgurl = length > 1 ? '' : imgUrlArr[0]
			let index = this.imgurl.lastIndexOf('.')
			let extension = this.imgurl.substring(index + 1, this.imgurl.length)
			let selectedItem = this.colorItems.filter(item => item.active)
			let color = selectedItem[0].color
			let params = {
				styleid: this.styleid,
				homeMap: {
					imgurl: this.imgurl,
					extension,
					colour: color
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/style/home/addOrUpdate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.getSetting()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getSetting () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/style/homePage`
			}).then(res => {
				if (res.result) {
					if (res.data.colour) {
						this.colorItems.forEach((item, index) => {
							if (item.color === res.data.colour) {
								this.colorItems[index].active = true
								this.color = item.color
							} else {
								this.colorItems[index].active = false
							}
						})
					} else {
						this.colorItems[0].active = true
						this.color = '#FFFFFF'
					}
					this.imgurl = res.data.imgurl ? res.data.imgurl : 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/biubiuorder/headerpic/wechatappletheader.jpg?timestamp=' + new Date().getTime()
					this.styleid = res.data.styleid ? res.data.styleid : ''
				} else {
					this.$message.error(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.pageSettingDetail-body{
  flex: 1
  display flex
  flex-direction column
  background: #eceffc
  padding: 0 !important;
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 23px;
    height: 64px
    background: #fff
		font-size: 14px
  }
  .gap {
    width: 100%
    height: 10px;
    background: #eceffc
  }
	.body-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row;
    justify-content: start;
    background: #fff
    .left {
      width: 267px;
      height: 100%;
      .component-title{
        cursor: pointer;
        display: flex;
        height:60px;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        padding-left: 44px;
        color: #333333;
				.margin-right-10 {
					margin-right: 12px
				}
      }
      .item-box{
				width: 80px;
				height: 100px;
        background: var(--fx-primary-color);
        color: #fff;
				display: flex;
				flex-direction: column;
				flex-shrink: 0;
				margin-left:50px;
				align-items: center;
				justify-content: center
        cursor: pointer
				img{
					width: 33px;
          height: 28px;
					margin-bottom: 12px;
				}
			}
    }
    .mid{
      width: 956px
      height: 100%;
      background-color: #fff;
      overflow: auto;
      margin:0 10px;
      display: flex;
      justify-content: center
      .phone{
        position: relative
        box-sizing: border-box;
        overflow-x: hidden;
        width: 570px;
        margin-top: 5%;
        height: 90%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        align-items: center
        .notice {
          position: absolute;
          left: 0;
          top: 67px;
          cursor: pointer
        }
        .me-back-Img {
          width: 333px;
          height: 167px;
          margin-top: 2px;
          // border: 2px solid var(--fx-primary-color);
          z-index: 1;
        }
        .info {
          display: flex;
          flex-flow: column;
          justify-content: center
          align-items: flex-start
          // color: #FFFFFF;
          font-size: 12px;
          line-height: 20px;
          position: absolute;
          left: 86px;
          top: 65px;
          .name {
            font-size: 16px;
          }
        }
        .phone-page {
          width: 375px;
          z-index: 2;
        }
				.border {
					position: absolute;
					width: 333px;
					height: 167px;
					border: 2px solid var(--fx-primary-color);
					z-index: 3;
				}
      }
    }
    .right {
      width: 525px;
      height: 100%;
      display: flex;
      flex-flow: column;
      text-align: left;
      .title-box{
        padding: 0 35px;
        margin-top: 23px;
        font-weight: bold;
        font-size: 18px;
        color: #333;
      }
      .second-title {
        margin: 30px 0 20px 35px;
        font-size: 12px;
        font-weight: bold;
        color: #333333;
      }
      .tips {
        font-size: 12px;
        color: #999;
        line-height: 24px;
        margin: 0 35px 29px 35px;
      }
      .uploadImgBox {
				display: flex;
				flex-flow: row;
				align-items: center;
        width: 445px;
        height: 116px;
        background: #FFFFFF;
        box-shadow: 1px 1px 6px 0px rgba(71, 71, 71, 0.2);
        border-radius: 4px;
        margin-left: 35px;
				.upload-title {
					margin-left: 23px;
					font-size: 12px;
					font-weight: bold;
					color: #333333;
				}
				.upload {
					width: 80px;
					height: 80px;
					margin: 0 21px;
				}
				.default {
					margin-left: 20px
				}
      }
			.color-box {
				display: flex;
				flex-flow: row;
				align-items: center;
				width: 445px;
				margin: 27px 0 0 35px;
				.color-title {
					font-size: 12px;
					font-weight: bold;
					color: #333333;
				}
				.color-picker {
					display: flex
					flex-flow: row
					align-items: center
					justify-content: space-around
					width: 180px
					.color {
						cursor: pointer
						width: 79px;
						height: 39px;
						border: 1px solid #CCCCCC;
						border-radius: 2px;
						background: #F6F7F9;
						display: flex
						align-items: center
						justify-content: center
						.color-content {
							width: 66px;
							height: 28px;
							border-radius: 2px;
						}
					}
					.active {
						border: 1px solid var(--fx-primary-color);
					}
					.default {
						margin-left: 20px
					}
				}
			}
    }
    .gap2 {
      width: 10px
      height: 100%
      background: #eceffc
    }
	}
}

</style>
<style lang="stylus">

</style>

